Router = App.loadClass 'core::Router'

class exports.KeyFieldsDefineRouter extends Router

    prefix: 'KeyFieldsDefine'
    module_name: 'KeyFieldsDefineRouter'

    register: () ->
        @module = angular.module @module_name, ['ui.router', 'ui.bootstrap']

        # Share singleton data
        @service 'portal::Angular/KeyFieldsDefine/ChangesToSave', [], 'ChangesToSave'

        # Define requests
        @service 'portal::Angular/KeyFieldsDefine/Service', ['$http']
        @service 'core::Angular/ReportFilters/FilterService', ['$http']

        # Sidebar controller
        @controller 'portal::Angular/KeyFieldsDefine/SidebarController',
            [
                '$scope', '$transitions',
                '$state',
                'KeyFieldsDefine.Services.FilterService',
                'KeyFieldsDefine.ChangesToSave',
                '$window'
            ]

        # Report controller
        @controller 'portal::Angular/KeyFieldsDefine/DefineController',
            [
                '$scope', '$transitions'
                '$state'
                'KeyFieldsDefine.Services.FilterService'
                'KeyFieldsDefine.Services.Service'
                '$window'
                'KeyFieldsDefine.ChangesToSave'
            ]



    registerRoutes: ($stateProvider) ->
        $stateProvider
            .state 'portal.keyfields_define',
                url: '/keyfields-define'
                templateUrl: 'backend/portal/key-fields-define/sidebar'
                controller: 'KeyFieldsDefine.Controllers.SidebarController'

            .state 'portal.keyfields_define.report',
                url: '/report'
                views:
                    'fullpage':
                        templateUrl: 'backend/portal/key-fields-define/footer'
                        controller: 'KeyFieldsDefine.Controllers.DefineController'
